import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30099eca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "abnormal" }
const _hoisted_2 = { class: "abnormal-list" }
const _hoisted_3 = {
  key: 1,
  class: "abnormal-item"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "abnormal-item-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"8px","font-size":"18px"}
}, null, -1))

import { ref, watch, watchEffect, Ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix, isD2C, isJA } from '@/store'
import { OrderTypeItem } from './UserOrder.vue'
import { UseType } from '@/common/const'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { DeliveryAbnormalOrderCount } from '@/apis/interface/customer'
import { useRouter } from 'vue-router'
enum ENUM_ABNORMAL_TYPE {
    /** 异常订单 */
    ABNORMAL_ORDER = '1',
    /** API自动下单异常 */
    ABNORMAL_AUTO_ORDER = '2',
    /** 待支付账单 */
    ABNORMAL_BILL = '3',
    /** OEM待确认报价 */
    ANNORMAL_OEM_QUOTE = '4',
    /** 待确认补货计划 */
    ABNORMAL_REPLENISHMENT = '5'
}

export default /*#__PURE__*/_defineComponent({
  props: {
    workbenchOrderInfo: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
    workbenchOrderInfo: DeliveryAbnormalOrderCount
}
const abnormalLis2C: OrderTypeItem [] = [
  {
    name: t('异常订单'),
    num: 0,
    path: 'AbnormalOrder',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_ORDER,
    position: 'abnormal_order'
  },
  {
    name: t('API自动下单异常'),
    num: 0,
    path: 'SyncOrder',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_AUTO_ORDER,
    position: 'abnormal_api_auto_order'
  },
  {
    name: t('待支付账单'),
    num: 0,
    path: 'BillList',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_BILL,
    position: 'to_be_paid_bill'
  },
  {
    name: t('OEM待确认报价'),
    num: 0,
    path: 'oemSourceList',
    orderStatus: ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE,
    position: 'to_be_confirmed_oem_quotation'
  }
]
const abnormalLis2B: OrderTypeItem [] = [
  {
    name: t('异常订单'),
    num: 0,
    path: 'AbnormalOrder',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_ORDER,
    position: 'abnormal_order'
  },
  {
    name: t('待支付账单'),
    num: 0,
    path: 'BillList',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_BILL,
    position: 'to_be_paid_bill'
  },
  {
    name: t('待确认补货计划1'),
    num: 0,
    path: 'ReplenishmentList',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT,
    position: 'pending_confirmation_replenishment_plan'
  },
  {
    name: t('OEM待确认报价'),
    num: 0,
    path: 'oemSourceList',
    orderStatus: ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE,
    position: 'to_be_confirmed_oem_quotation'
  }
]
const abnormalList: Ref<OrderTypeItem[]> = ref(isD2C() ? abnormalLis2C : abnormalLis2B)



watchEffect(() => {
  const newArr = [...abnormalList.value]
  const workbenchOrderInfo = props?.workbenchOrderInfo
  newArr.map((item) => {
    if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_ORDER) {
      item.num = (
        Number(workbenchOrderInfo?.abnormalOrderCount) +
        Number(workbenchOrderInfo?.wholeProcessOrderCount) +
       Number(workbenchOrderInfo?.skuProcessOrderCount)) || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_AUTO_ORDER) {
      item.num = workbenchOrderInfo?.notFinishedOrderCount || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_BILL) {
      item.num = workbenchOrderInfo?.unpaidBillNum || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE) {
      item.num = workbenchOrderInfo?.waitConfirm || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT) {
      item.num = workbenchOrderInfo?.noConfirmReplenishPlanCount || 0
    }
  })
})

const router = useRouter()
const handleAppLink = (item: OrderTypeItem) => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: item.position
    }
  })
  if (item.orderStatus === ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE) {
    window.location.href = window.location.origin + '/oem/order/oemSourceList?status=13,16'
  } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT) {
    return router.push(useRtfix(item.path as string, { query: { planStatus: 1 } }))
  } else {
    return router.push(useRtfix(item.path as string))
  }
}

const handleAppLinkOther = (item: OrderTypeItem) => {
  const workbenchOrderInfo = props?.workbenchOrderInfo
  if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_ORDER) {
    /** 异常订单-未处理 */
    if (Number(workbenchOrderInfo?.abnormalOrderCount)) {
      return useRtfix(item.path as string)
    } else if (workbenchOrderInfo?.wholeProcessOrderCount) {
      /** 异常-待确认运输方式-整单确认 */
      return useRtfix(item.path as string, { query: { abnormal: 'ConfirmType', deliveryProcessType: 0 } })
    } else if (workbenchOrderInfo?.skuProcessOrderCount) {
      /** 异常-待确认运输方式-按SKU确认 */
      return useRtfix(item.path as string, { query: { abnormal: 'ConfirmType', deliveryProcessType: 1 } })
    } else {
      /** 异常订单-未处理 */
      return useRtfix(item.path as string)
    }
  }
  if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT) {
    return useRtfix(item.path as string, { query: { planStatus: 1 } })
  }
  return useRtfix(item.path as string)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(abnormalList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (!_unref(isJA)() && item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "abnormal-item-content",
                  onClick: ($event: any) => (handleAppLink(item))
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["abnormal-item-num", Number(item?.num) > 0 ? 'red': ''])
                  }, _toDisplayString(Number(item?.num) > 99 ? '99+' : item.num), 3)
                ], 8, _hoisted_4),
                _hoisted_6
              ]))
        ]))
      }), 128))
    ])
  ]))
}
}

})